import React from 'react'
import { Trophy, Star, Award, Crown } from 'lucide-react'
import strategyLevelService from '../services/strategyLevelService'
import './StrategyLevelBadge.css'

/**
 * Displays a visual badge for a user's level in a strategy
 * Color-coded by tier: bronze (1-3), silver (4-6), gold (7-9), platinum (10)
 */
const StrategyLevelBadge = ({
  level,
  size = 'medium',
  showLabel = true,
  showIcon = true,
  animated = false
}) => {
  if (!level || level < 1 || level > 10) {
    return null
  }

  const levelInfo = strategyLevelService.getLevelInfo(level)
  const sizeClass = `badge-${size}`
  const animatedClass = animated ? 'badge-animated' : ''

  const getIcon = () => {
    switch (levelInfo.tier) {
      case 'bronze':
        return <Trophy className="badge-icon" />
      case 'silver':
        return <Star className="badge-icon" />
      case 'gold':
        return <Award className="badge-icon" />
      case 'platinum':
        return <Crown className="badge-icon" />
      default:
        return <Trophy className="badge-icon" />
    }
  }

  return (
    <div className={`strategy-level-badge ${levelInfo.tier} ${sizeClass} ${animatedClass}`}>
      {showIcon && <div className="badge-icon-wrapper">{getIcon()}</div>}
      <div className="badge-content">
        <div className="badge-level">Level {level}</div>
        {showLabel && <div className="badge-label">{levelInfo.name}</div>}
      </div>
    </div>
  )
}

export default StrategyLevelBadge
